import { render } from "./VipLogsEdit.vue?vue&type=template&id=5745c424"
import script from "./VipLogsEdit.vue?vue&type=script&lang=js"
export * from "./VipLogsEdit.vue?vue&type=script&lang=js"

import "./VipLogsEdit.vue?vue&type=style&index=0&id=5745c424&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__